import {seaCampaign} from '@/api/directus/seaCampaign';

export type {SeaCampaignResponse} from '@/api/directus/seaCampaign';

const api = {seaCampaign};

export default api;
